'use client';

import { c as _c } from "react/compiler-runtime";
import type { Data } from '@repo/strapi-types';
import AppLink from '@/components/elementary/AppLink';
import { CTAButtons } from '@/components/elementary/navbar/desktop/CTAButtons';
import { NavbarMenuPanel } from '@/components/elementary/navbar/desktop/NavbarMenuPanel';
import { Paragraph } from '@/components/typography/Paragraph';
import { NavigationMenu, NavigationMenuItem, NavigationMenuList, NavigationMenuTrigger, navigationMenuTriggerStyle } from '@/components/ui/navigation-menu';
import { NAVBAR_TEST_IDS } from '@/lib/test-ids';
import { SeoNavigationFallback } from '../SeoNavigationFallback';
interface DesktopNavigationProps {
  items?: Data.Component<'layout-utilities.navbar-item'>[] | null;
  login?: Data.Component<'utilities.link'> | null;
  buttons?: Data.Component<'utilities.link'>[] | null;
  dropdown?: Data.Component<'layout-utilities.dropdown-item'> | null;
  minimal?: boolean;
}
export function DesktopNavigation(t0) {
  const $ = _c(18);
  const {
    items,
    login,
    buttons,
    dropdown,
    minimal
  } = t0;
  let t1;
  if ($[0] !== buttons || $[1] !== dropdown || $[2] !== items || $[3] !== login) {
    t1 = <SeoNavigationFallback items={items} login={login} buttons={buttons} dropdown={dropdown} />;
    $[0] = buttons;
    $[1] = dropdown;
    $[2] = items;
    $[3] = login;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  let t2;
  if ($[5] !== items) {
    t2 = Array.isArray(items) && items.map(_temp);
    $[5] = items;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  let t3;
  if ($[7] !== buttons || $[8] !== dropdown || $[9] !== login || $[10] !== minimal) {
    t3 = <CTAButtons login={login} buttons={buttons} dropdown={dropdown} minimal={minimal} />;
    $[7] = buttons;
    $[8] = dropdown;
    $[9] = login;
    $[10] = minimal;
    $[11] = t3;
  } else {
    t3 = $[11];
  }
  let t4;
  if ($[12] !== t2 || $[13] !== t3) {
    t4 = <NavigationMenu viewport={false} className="desktop-nav"><NavigationMenuList className="hidden lg:flex gap-8 items-center h-5.5" data-test-id={NAVBAR_TEST_IDS.NAVIGATION_ITEMS}>{t2}{t3}</NavigationMenuList></NavigationMenu>;
    $[12] = t2;
    $[13] = t3;
    $[14] = t4;
  } else {
    t4 = $[14];
  }
  let t5;
  if ($[15] !== t1 || $[16] !== t4) {
    t5 = <>{t1}{t4}</>;
    $[15] = t1;
    $[16] = t4;
    $[17] = t5;
  } else {
    t5 = $[17];
  }
  return t5;
}
function _temp(item) {
  return <NavigationMenuItem key={item.id}>{item.href ? <AppLink link={item} variant="primaryLink" data-test-id={NAVBAR_TEST_IDS.NAVIGATION_ITEM}><Paragraph fontSize="bodyRegularMedium" className="text-inherit">{item.label}</Paragraph></AppLink> : <NavigationMenuTrigger data-test-id={NAVBAR_TEST_IDS.NAVIGATION_ITEM} className={navigationMenuTriggerStyle()}><Paragraph fontSize="bodyRegularMedium" className="text-inherit">{item.label}</Paragraph></NavigationMenuTrigger>}{item.columns && <NavbarMenuPanel columns={item.columns} />}</NavigationMenuItem>;
}